module.exports = {
  LOCAL: {
    API_BASE_URL: "https://api-dev.cateringrewards.com",
    API_LANDING_PAGE_BASE_URL: "http://localhost:3001",
    ENV: "local",
    NOTIFICATION_EMAIL: "noreply-dev@cateringrewards.com",
    GTM_ENABLED: false,
    GOOGLE_CLIENT_ID: "744531691486-g25521q34ch275pms7hj3q04pd59k58u.apps.googleusercontent.com",
    GOOGLE_REDIRECT_URI: "http://localhost:3000/authentication/sign-in",
    GTM_ID: "GTM-N4G9BHVK",
  },
  DEV: {
    API_BASE_URL: "https://api-dev.cateringrewards.com",
    API_LANDING_PAGE_BASE_URL: "https://landing-dev.cateringrewards.com",
    ENV: "dev",
    BUGSNAG_API_KEY: "0a00acd4419af29eefcb68b175aca42f",
    BUGSNAG_RELEASE_STAGE: "development",
    NOTIFICATION_EMAIL: "noreply-dev@cateringrewards.com",
    GTM_ENABLED: true,
    GOOGLE_CLIENT_ID: "744531691486-g25521q34ch275pms7hj3q04pd59k58u.apps.googleusercontent.com",
    GOOGLE_REDIRECT_URI: "https://user-dev.cateringrewards.com/authentication/sign-in",
    GTM_ID: "GTM-N4G9BHVK",
  },
  STAGING: {
    API_BASE_URL: "https://api-staging.cateringrewards.com",
    API_LANDING_PAGE_BASE_URL: "https://landing-staging.cateringrewards.com",
    ENV: "staging",
    BUGSNAG_API_KEY: "0a00acd4419af29eefcb68b175aca42f",
    BUGSNAG_RELEASE_STAGE: "staging",
    NOTIFICATION_EMAIL: "noreply-staging@cateringrewards.com",
    GTM_ENABLED: true,
    GOOGLE_CLIENT_ID: "744531691486-g25521q34ch275pms7hj3q04pd59k58u.apps.googleusercontent.com",
    GOOGLE_REDIRECT_URI: "https://user-staging.cateringrewards.com/authentication/sign-in",
    GTM_ID: "GTM-5DF8767V",
  },
  PRE_PROD: {
    API_BASE_URL: "https://api-pre-prod.cateringrewards.com",
    API_LANDING_PAGE_BASE_URL: "https://landing-pre-prod.cateringrewards.com",
    ENV: "pre_prod",
    BUGSNAG_API_KEY: "0a00acd4419af29eefcb68b175aca42f",
    BUGSNAG_RELEASE_STAGE: "pre-production",
    NOTIFICATION_EMAIL: "noreply-pre-prod@cateringrewards.com",
    GTM_ENABLED: true,
    GOOGLE_CLIENT_ID: "744531691486-g25521q34ch275pms7hj3q04pd59k58u.apps.googleusercontent.com",
    GOOGLE_REDIRECT_URI: "https://user-pre-prod.cateringrewards.com/authentication/sign-in",
  },
  PROD: {
    API_BASE_URL: "https://api.cateringrewards.com",
    API_LANDING_PAGE_BASE_URL: "https://cateringrewards.com",
    ENV: "prod",
    BUGSNAG_API_KEY: "0a00acd4419af29eefcb68b175aca42f",
    BUGSNAG_RELEASE_STAGE: "production",
    NOTIFICATION_EMAIL: "<noreply@cateringrewards.com",
    GTM_ENABLED: true,
    GOOGLE_CLIENT_ID: "491822101832-o1lnjl8e1hvd7k3lbsnaf285hdh1f5k8.apps.googleusercontent.com",
    GOOGLE_REDIRECT_URI: "https://my.cateringrewards.com/authentication/sign-in",
    GTM_ID: "GTM-M5B3S9M3",
  },
};
